import { useContext, useEffect, useState } from "react";
import { PricingPortalAPI } from "../apis/pricing-api";
import { DisplaySpinnerContext } from "../context/ContextIndex";

const useBranchCostConfigList = (businessCode, countryCode) => {
  const [branchCostConfigList, setBranchCostConfigList] = useState();
  const spinnerCtx = useContext(DisplaySpinnerContext);

  useEffect(() => {
    const fetchBranchCostConfigList = async () => {
      try {
        let _branchCostConfigList = await PricingPortalAPI.getList(
          businessCode,
          countryCode,
          "getBranchCostConfigList",
          "branchcostconfig"
        );

        await setBranchCostConfigList(_branchCostConfigList);
      } catch (e) {
        spinnerCtx.setLoadingIndicator(false);
        alert(e);
      }
    };
    fetchBranchCostConfigList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return branchCostConfigList;
};

export { useBranchCostConfigList };
